import Api from './config';

export function getLHREquipment() {
    return Api.request({
        method: 'GET',
        url: '/equipment/lhr-treatment'
    });
}
